export const SKILL_OPTIONS = [
  "Manicure",
  "Pedicure",
  "Acrylic Nails",
  "Bio Gel Nails",
  "Nail Art Designs",
  "Waxing",
  "Eyelash Extensions",
  "Facials",
  "Other",
];

export const LANGUAGE_OPTIONS = [
  "English",
  "French",
  "Spanish",
  "Vietnamese",
  "Other",
];

export const YEARS_OPTIONS = [
  "1 year or less",
  "2–3 years",
  "4–5 years",
  "Other",
];
